<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M30 20V18H38V26H36V21.41L30.13 27.29L28.71 25.87L34.59 20H30ZM20 34.58L25.88 28.7L27.3 30.12L21.42 36H26V38H18V30H20V34.58Z" fill="#D89F9B"/>
</svg>
